// @flow

import React, {lazy, Suspense} from "react";
import Webcam from "react-webcam";
import {useTranslation} from "react-i18next";
import {useWebcamPopup} from "@bfg/effects/webcamPopup";
import {useWebcam} from "@bfg/effects/webcam";

const LazyPopup = lazy(() => import('reactjs-popup'));

export const WebcamButton = (props: any) => {
  const {t} = useTranslation();
  let width = window.document.documentElement.clientWidth * 0.9;
  if (width > 640) {
    width = 640;
  }

  const webcamPopup = useWebcamPopup();
  const webcamHandler = useWebcam(props.parent, width, props.subscriberId);

  const webcamPopUpOpenAndPreventDefault = (e) => {
    e.preventDefault()
    webcamPopup.openPopup()
  }
  
  const takePicAndClosePopupHandler = () => {
    webcamHandler.takePic();
    webcamPopup.closePopup();
  }

  return (
    <>
      <button className="btn popup-btn"
              title={t('parent.buttons.Take a Selfie')}
              onClick={webcamPopUpOpenAndPreventDefault}
      >
        {!props.isMobile && (<span className="bm_icon_camera"/>)}
        {t('parent.buttons.Take a Selfie')}
      </button>
      <Suspense fallback={<></>}>
        <LazyPopup
          open={webcamPopup.popupOpen}
          onClose={webcamPopup.closePopup}
          contentStyle={{width: 'auto'}}
          modal
        >
          <>
            <Webcam
              forceScreenshotSourceSize={false}
              audio={false}
              mirrored={true}
              ref={webcamHandler.ref}
              screenshotFormat="image/jpeg"
              videoConstraints={webcamHandler.videoConfig}
              width={width}
              height={width}
            />
            <button className="btn"
                    title={t('parent.buttons.Take a Selfie')}
                    onClick={takePicAndClosePopupHandler}>
              <span className="bm_icon_camera"/>{t('parent.buttons.Take a Selfie')}
            </button>
          </>
        </LazyPopup>
      </Suspense>
    </>
  );
}
